/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var WarningTriangleIcon64Regular = forwardRef('WarningTriangleIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M34 44a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" }),
        React.createElement("path", { d: "M33.5 21.5a1.5 1.5 0 0 0-3 0v15a1.5 1.5 0 0 0 3 0v-15Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M25.574 9.766c2.915-4.842 9.937-4.842 12.852 0L58.81 43.632C61.82 48.631 58.22 55 52.385 55h-40.77C5.78 55 2.18 48.63 5.189 43.632L25.574 9.766Zm10.281 1.547c-1.749-2.905-5.961-2.905-7.71 0L7.759 45.18C5.954 48.18 8.114 52 11.615 52h40.77c3.501 0 5.661-3.822 3.856-6.82L35.855 11.312Z" })));
});
